import React from "react";
import PropTypes from "prop-types";
import { Box, Button, DialogActions, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

import RpMUIDialog from "@/components/modals/RpMUIModal";

const UserActionConfirmModal = ({
  open,
  title,
  children,
  confirmLabel,
  primaryFirst = false,
  variant = "warning",
  showCancel = true,
  onClose,
  onConfirm,
}) => {
  const isSuccess = variant === "success";
  const primaryButton = (
    <Button
      variant="contained"
      className="text-capitalize fw-sb"
      onClick={onConfirm}
      sx={
        isSuccess
          ? { minWidth: { xs: "100%", sm: 412 }, minHeight: 45 }
          : undefined
      }
    >
      {confirmLabel}
    </Button>
  );

  const cancelButton = (
    <Button
      variant="outlined"
      color="inherit"
      className="text-capitalize fw-sb"
      onClick={onClose}
    >
      Cancel
    </Button>
  );

  return (
    <RpMUIDialog open={open} onClose={onClose} maxWidth="sm">
      <Box className="text-center" sx={{ px: { xs: 1, sm: 3 }, py: 3 }}>
        {isSuccess ? (
          <Box
            className="d-inline-flex align-items-center justify-content-center mb-4"
            sx={{
              width: 78,
              height: 78,
              borderRadius: "var(--radius-round)",
              bgcolor: "primary.main",
              color: "primary.contrastText",
            }}
          >
            <CheckIcon sx={{ fontSize: 48, fontWeight: 700 }} />
          </Box>
        ) : (
          <Box
            component="img"
            src="/img/icons/info.svg"
            alt="Warning"
            className="mb-4"
          />
        )}

        <Typography
          variant={isSuccess ? "h5" : "h6"}
          className="mb-3"
          sx={{ color: "var(--palette-text-primary)", fontWeight: 700 }}
        >
          {title}
        </Typography>

        <Typography
          className="mb-4 text-break"
          sx={{
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            ...(isSuccess ? { lineHeight: 1.6 } : {}),
          }}
        >
          {children}
        </Typography>

        <DialogActions className="justify-content-center" sx={{ gap: 1 }}>
          {!showCancel ? (
            primaryButton
          ) : primaryFirst ? (
            <>
              {primaryButton}
              {cancelButton}
            </>
          ) : (
            <>
              {cancelButton}
              {primaryButton}
            </>
          )}
        </DialogActions>
      </Box>
    </RpMUIDialog>
  );
};

UserActionConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  primaryFirst: PropTypes.bool,
  variant: PropTypes.oneOf(["warning", "success"]),
  showCancel: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default UserActionConfirmModal;
